import {
  NumberRangeFilterPopover,
  NumberRangeFilterPopoverProps,
  NumberRangeFilterPopoverTrigger,
} from 'src/common/primitives/NumberRangeFilterPopover/NumberRangeFilterPopover';

interface PriceFilterProps
  extends Omit<
    NumberRangeFilterPopoverProps,
    'triggerElement' | 'entityLabel'
  > {
  triggerElement?: NumberRangeFilterPopoverProps['triggerElement'];
}

export function PriceFilter(props: PriceFilterProps) {
  const hasValue = !!(
    props.value &&
    ((props.value.min && !isNaN(props.value.min)) ||
      (props.value.max && !isNaN(props.value.max)))
  );

  return (
    <NumberRangeFilterPopover
      type="currency"
      entityLabel="Price"
      triggerElement={
        <NumberRangeFilterPopoverTrigger
          hasValue={hasValue}
          label="Trip Price"
        />
      }
      {...props}
    />
  );
}
